import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link as RouterLink } from 'react-router';

const EXTERNAL = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

/**
 * Adapter that lets Astryx components keep using `href` while internal
 * navigation goes through React Router instead of a full page load.
 *
 * Installed once via `<LinkProvider component={AppLink}>`.
 */
export const AppLink = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(
  function AppLink({ href, children, ...rest }, ref) {
    if (!href || EXTERNAL.test(href) || href.startsWith('#')) {
      return (
        <a ref={ref} href={href} {...rest}>
          {children}
        </a>
      );
    }
    return (
      <RouterLink ref={ref} to={href} {...rest}>
        {children}
      </RouterLink>
    );
  },
);
